import React from 'react'
import { Redirect } from 'react-router-dom'
import { getOfferingsPath, OFFERINGS_TAB } from '../offerings/routes'

const BookingTypesPage = () => (
  <Redirect to={getOfferingsPath(OFFERINGS_TAB.BOOKING_TYPE)} />
)

export default BookingTypesPage
